import { skipToken, useQuery } from '@tanstack/react-query'

import { captureException } from '@/src/config/sentry'

import { pageApi } from '../api/pageApi'

export const usePageQuery = (slug?: string) =>
  useQuery({
    queryKey: ['page', slug],
    enabled: !!slug,
    queryFn: slug
      ? async ({ signal }) => {
          const { content, ...rest } = await pageApi.getPage(slug, { signal })
          const url = /<iframe[^>]*src="([^"]*notion[^"]*)"[^>]*>/g.exec(content)?.[1]
          if (!url) {
            const error = new Error('No Notion iframe found in page content')
            captureException.then((f) => f(error))
            throw error
          }
          return { ...rest, url }
        }
      : skipToken,
  })
